package com.nonopn.skydome.common.app.pages.main.view.map

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.VectorPainter
import com.nonopn.skydome.common.app.pages.main.model.MainScreenModel
import com.nonopn.skywatcher.design.theme.AppSizes
import com.nonopn.skywatcher.design.theme.LocalApplicationColorTheme
import eu.codlab.compose.widgets.TextNormal

@Composable
fun CounterDefault(
    modifier: Modifier,
    vectorPainter: VectorPainter,
    value: String,
    onClick: (() -> Unit)? = null
) {
    val colors = LocalApplicationColorTheme.current

    MapOverlayCard(
        modifier = modifier,
        onClick = onClick,
    ) {
        Row(
            modifier = Modifier.fillMaxSize().padding(
                horizontal = AppSizes.map.cardHorizontalPadding,
                vertical = AppSizes.map.cardVerticalPadding
            ),
            horizontalArrangement = Arrangement.spacedBy(AppSizes.map.cardHorizontalPadding),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = vectorPainter,
                contentDescription = "-",
                tint = colors.fonts.regular
            )

            Column(Modifier.weight(1.0f)) { /* nothing */ }

            TextNormal(
                text = value
            )
        }
    }
}
